import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() properties!: { name?: string, type?: string, symbol?: string, function?: string };
  @Input() template?: any;
  @Output() onButtonClick: EventEmitter<any> = new EventEmitter();
  
  isDisabled: boolean = false;

  ngOnInit(): void {
    const userClaim = localStorage.getItem("userClaim");

    if (userClaim) {
      try {
        const parsedClaim = JSON.parse(userClaim);
        this.isDisabled = parsedClaim.IsDisabled?.toLowerCase() === "true";
      } catch (error) {
        console.error("Error parsing userClaim from localStorage", error);
      }
    }
  }

  onClick() {
    this.onButtonClick.emit();
  }
}